import { useLocalStorage } from "Hooks/useLocalStorage";

type PluginAppsConfiguration = { isDevelopmentModeEnabled: boolean };

export const usePluginAppsConfiguration = () =>
  useLocalStorage<PluginAppsConfiguration>("plugin-apps-configuration");
